<script setup lang="ts">
import { BenefitCardTypeEnum } from '~/types';

withDefaults(defineProps<{
  title: string;
  description: string;
  image: string;
  type?: keyof typeof BenefitCardTypeEnum;
}>(), {
  type: BenefitCardTypeEnum.primary,
});

const types: Record<keyof typeof BenefitCardTypeEnum, string> = {
  primary: 'pt-6 pl-6 pr-6 pb-16 xs:pb-14 xs:pr-4 xs:pl-8 sm:pb-16',
  secondary: 'grid pt-6 pl-6 pr-6 pb-16 xs:py-7 xs:pr-4 xs:pl-8 xs:grid-cols-[1.2fr_1fr] xs:gap-8 sm:py-8',
};

const descriptionStyles: Record<keyof typeof BenefitCardTypeEnum, string> = {
  primary: '2xs:max-w-[70%] xs:max-w-[70%] sm:max-w-[60%]',
  secondary: '2xs:max-w-[70%] xs:max-w-none',
};

const imageStyles: Record<keyof typeof BenefitCardTypeEnum, string> = {
  primary: 'opacity-40 w-40 h-32 2xs:opacity-100 xs:w-[40%] xs:h-32 sm:h-40 sm:w-[36%]',
  secondary: 'opacity-40 w-40 h-32 2xs:opacity-100 xs:h-[80%] xs:w-[35%] xs:my-auto',
};
</script>

<template>
  <div :class="[types[type], 'relative bg-jungle-50 rounded-layout border-2 border-viola-600 overflow-hidden py-8 pl-8 pr-4 sm:py-10 sm:pl-11']">
    <div class="relative z-10 text-viola-600">
      <h4 class="font-bold leading-default text-2xl sm:text-3xl">
        {{ title }}
      </h4>

      <p :class="[descriptionStyles[type], 'leading-[1.35] mt-5 text-xl xs:text-default-md fhd:text-md 4k:text-lg']">
        {{ description }}
      </p>
    </div>

    <div :class="[imageStyles[type], 'absolute bottom-0 right-0 z-1 flex justify-end']">
      <NuxtImg
        class="w-full h-full object-cover object-left-top"
        :src="image"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
